<div class="layout">
    <app-nav-bar>
        <app-navigation-link text="Home" link="home" icon="fa-archive"></app-navigation-link>
        <app-navigation-link text="User" link="userdetails" icon="fa-user"></app-navigation-link>
        <app-navigation-link text="Account" link="accountgrid" icon="fa-traffic-light"></app-navigation-link>
        <app-navigation-link text="Test" (navigate)="onExecuteTest()" icon="fa-flask"></app-navigation-link>
        <app-navigation-link text="Dialogs" link="dialogs" icon="fa-flask"></app-navigation-link>
        <app-navigation-link text="Controls" link="controls" icon="fa-check"></app-navigation-link>
        <app-navigation-link text="Grid Layout" link="flexgridlayout" icon="fa-table"></app-navigation-link>
        <app-navigation-link text="Config Matrix" link="configmatrix" icon="fa-grid"></app-navigation-link>
        <app-navigation-link text="Tooltips" link="componenttooltip" icon="fa-comment"></app-navigation-link>
        <app-navigation-link text="Editor" link="monaco" icon="fa-input-text"></app-navigation-link>
        <app-navigation-link text="View Editor" link="vieweditor" icon="fa-list-tree"></app-navigation-link>
        <app-navigation-link text="Fluent Datagrid" link="fuidatagrid" icon="fa-list-tree"></app-navigation-link>
        <app-navigation-link text="Sheet" link="sheet" icon="fa-file-excel"></app-navigation-link>
        <app-navigation-link text="Signals" link="signals" icon="fa-file-excel"></app-navigation-link>
        <app-navigation-link text="Users" link="useradmin" icon="fa-users"></app-navigation-link>
        <app-navigation-link text="Comments" link="commenteditor" icon="fa-edit"></app-navigation-link>
        <app-navigation-link text="Account Comments" link="accountcommentseditor" icon="fa-edit"></app-navigation-link>
        <app-navigation-link text="ATS Scatter" link="atsscatterchart" icon="fa-chart-scatter"></app-navigation-link>
        <app-navigation-link text="Waterfall" link="waterfallchart" icon="fa-chart-waterfall"></app-navigation-link>
        <app-navigation-link text="OPA" link="opa" icon="fa-bathtub"></app-navigation-link>

        <div style="flex: 1">&nbsp;</div>
        <div class="menu-divider"></div>
        <div class="app-user-name" (click)="onShowUserDetails()">{{authService.appUser()?.name}}</div>
        @if(!authService.isAuthenticated()) {
            <app-navigation-link text="Login" icon="fa fa-door-open" (click)="onUserLogin()"></app-navigation-link>
        } @else {
            <app-navigation-link text="Logout" icon="fa fa-door-closed" (click)="onUserLogout()"></app-navigation-link>
        }
    </app-nav-bar>
    <main>
        <router-outlet></router-outlet>
    </main>
    <footer>
        LLMs are fallible and may produce incorrect or misleading information.. Verify any critical advice with a professional.
    </footer>
</div>
